import { Navigate, useLocation } from "react-router-dom";

const isAdmin = () =>
  typeof window !== "undefined" &&
  localStorage.getItem("isLoggedIn") === "true";

export function RequireAdmin({ children }) {
  const location = useLocation();
  if (!isAdmin()) {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    );
  }
  return children;
}
